/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { amlQuery } from '../../data/amlcontent';
import { gatherMLContent } from '../../helpers/gather-ml-content';
import './_navbar.scss';

const NavBar = () => {
  const [menuActive, setMenuActive] = useState(false);
  useEffect(() => {
    const navBar = document.querySelector('.navbar');
    const homeHero = document.querySelector('.home__hero');
    if (homeHero) {
      const heroObserver = new IntersectionObserver(
        ([e]) => {
          navBar.toggleAttribute('top', !e.isIntersecting);
        },
        { threshold: [0] },
      );
      heroObserver.observe(homeHero);
    }
  }, []);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const navItemsData = amlQuery();
  const navItems = gatherMLContent(navItemsData, 'navbar');
  const title = gatherMLContent(navItemsData, 'title');

  return (
    <nav className={`navbar ${(menuActive ? 'menu-active' : '')}`}>
      <div className="navbar__menu-icon" role="button" tabIndex="0" onClick={() => toggleMenu()}>X</div>
      <Link to="/" className="navbar__title">
        {title}
      </Link>
      <ul className="navbar__items">
        {navItems.map((item, index) => (

          <li className="navbar__item" key={index}>
            {(item.link.includes('http') ? (
              <a href={item.link} className="navbar__link" target="_blank" rel="nofollow noreferrer">{item.title}</a>
            )
              : (
                <Link to={item.link} className="navbar__link" activeClassName="active">{item.title}</Link>
              ))}

          </li>
        ))}
      </ul>
    </nav>

  );
};

export default NavBar;
